export default "__VITE_ASSET__D2lbpLK4__"